import { Component, OnInit } from "@angular/core";
import { EventType, Router } from "@angular/router";
import { RouteToTitleMap } from "./header.constants";
import { Routes, RouteToTooltipMap } from "../../../../models/route.models";

@Component({
	selector: "app-header-nav",
	imports: [],
	templateUrl: "./header-nav.component.html",
	styleUrl: "./header-nav.component.css",
	standalone: true,
})
export class HeaderNavComponent implements OnInit {
	routeName: string = "";
	showingTooltip = false;
	tooltip: { title: string; body: string } | undefined;
	constructor(private router: Router) {}
	ngOnInit() {
		this.router.events.subscribe((event) => {
			if (event.type === EventType.NavigationEnd) {
				const url = event.url;
				const routeString = url.split("/").pop() as Routes;
				let routeName = RouteToTitleMap[routeString];
				if (!routeName) {
					console.warn("Route not found", routeString);
					console.log(event.url.split("/"));
					routeName = RouteToTitleMap[event.url.split("/")[1] as Routes];
				}
				this.tooltip = RouteToTooltipMap[routeString];
				this.routeName = routeName;
			}
		});
	}

	showTooltip() {
		this.showingTooltip = true;
	}
	hideTooltip() {
		this.showingTooltip = false;
	}
}
